/**
 * Maps an array of data items to a template.
 * @param {Array} results
 * @param {jQuery} $itemTemplate
 * @return {Element[]}
 */
const mapDownloadDataToTemplate = (results, $itemTemplate) => (
    results.map(entry => {
        const $item = $itemTemplate.clone();
        $item.find('[data-title]').text(entry.title);
        $item.find('[data-filename]').text(entry.filename);
        $item.find('[data-filetype]').text(entry.filetype);
        $item.find('[data-filesize]').text(entry.filesize);
        $item.find('[data-url]').attr('href', entry.url);

        return $item.get(0);
    })
);

export default mapDownloadDataToTemplate;



// WEBPACK FOOTER //
// ./src/scripts/components/search/mapDownloadDataToTemplate.js